import { removeNamespace } from '@piri/vue-utils';

import { fetchSites, fetchSite } from '@/api/site/SiteApi';
import moduleName from './moduleName';
import actionTypes from './types/actionTypes';
import mutationTypes from './types/mutationTypes';

const actionTypesInModule = removeNamespace(moduleName, actionTypes);
const mutationTypesInModule = removeNamespace(moduleName, mutationTypes);

const retrieveSites = async ({ context }) => {
  const sites = await fetchSites();
  context.commit(mutationTypesInModule.SITES_UPDATED, sites);

  return sites;
};

const retrieveSite = async (context, { id }) => {
  const site = await fetchSite(id);
  context.commit(mutationTypesInModule.SITE_UPDATED, site);

  return site;
};

const setSelected = async (context, { id }) => {
  const site = await fetchSite(id);
  context.commit(mutationTypesInModule.SELECTED_UPDATED, site);

  return site;
};

export default {
  [actionTypesInModule.RETRIEVE_SITES]: retrieveSites,
  [actionTypesInModule.RETRIEVE_SITE]: retrieveSite,
  [actionTypesInModule.SET_SELECTED]: setSelected,
};
